import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../css/HorizontalCollapsibleSectionStyling.css';

const HorizontalCollapsibleSection = ({
                                          title,
                                          icon: IconComponent,
                                          iconColor = "default-icon-color",
                                          badge,
                                          children,
                                          defaultExpanded = false,
                                          headerClassName = "",
                                          contentClassName = ""
                                      }) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div className={`horizontal-collapsible ${isExpanded ? 'expanded' : ''}`}>
            <div className={`horizontal-header ${isExpanded ? 'expanded' : ''}`}>
                <button
                    onClick={toggleExpanded}
                    className="horizontal-toggle"
                >
                    {isExpanded ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
                </button>

                <div className="horizontal-header-content">
                    {IconComponent && (
                        <IconComponent size={28} className={`icon-component ${iconColor}`} />
                    )}
                    <h3 className="horizontal-title">{title}</h3>
                    {badge && <span className="horizontal-badge">{badge}</span>}
                </div>
            </div>

            <div className={`horizontal-content ${isExpanded ? 'open' : 'closed'}`}>
                <div className={`horizontal-panel ${isExpanded ? 'open' : 'closed'}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default HorizontalCollapsibleSection;
